import {
  createSlice,
  Draft,
  PayloadAction
} from '@reduxjs/toolkit'
import { RootState } from '../../app/store'

export type NetworkState = {
  online: boolean
}

const initialState: NetworkState = {
  online: navigator.onLine
}

export const networkSlice = createSlice({
  name: 'network',
  initialState,
  reducers: {
    setOnline: (state: Draft<NetworkState>, action: PayloadAction<boolean>) => {
      state.online = action.payload
    }
  }
})

export const { setOnline } = networkSlice.actions

export const getOnlineSelector = (state: RootState): boolean => state.network?.online

export default networkSlice.reducer
